import React from 'react'
import { Wrap, WrapItem } from '@chakra-ui/react'

import { PatientIdAndName } from './types'
import { SetStateFn } from '~config/constants'
import ChipButton from '~components/shared/form/chip-button'
import SharedStack from '~components/shared/wrappers/shared-stack'
import SharedSectionHeader from '~components/shared/texts/shared-section-header'
import InfoTooltip from '~components/shared/info-tooltip'
import { getCopyTemplateMissingInfoHelp } from './missing-info-help'

interface Props {
    patients: PatientIdAndName[]
    patientId: string | undefined
    setPatientId: SetStateFn<string | undefined>
    needsShowMore: boolean
    showMore: boolean
    setShowMore: SetStateFn<boolean>
}

export default function MessageTemplatePatients({
    patients,
    patientId,
    setPatientId,
    needsShowMore,
    showMore,
    setShowMore,
}: Props) {
    const missingPatientHelp = getCopyTemplateMissingInfoHelp({
        missingPatient: !patientId,
        missingAppointment: false,
    })

    return (
        <SharedStack spacing={2}>
            <SharedStack row spacing={1} align="center">
                <SharedSectionHeader mb={0}>Select a patient</SharedSectionHeader>
                <InfoTooltip
                    tooltip={
                        missingPatientHelp ||
                        'Choose which pet this template should use for tags like pet name.'
                    }
                />
            </SharedStack>
            <Wrap>
                {patients.map(patient => (
                    <WrapItem key={patient.id}>
                        <ChipButton
                            isActive={patient.id === patientId}
                            onClick={() => {
                                patientId === patient.id
                                    ? setPatientId(undefined)
                                    : setPatientId(patient.id)
                            }}
                        >
                            {patient.name}
                        </ChipButton>
                    </WrapItem>
                ))}
                {needsShowMore && (
                    <WrapItem>
                        <ChipButton
                            isActive={false}
                            onClick={() => {
                                setShowMore(prev => !prev)
                            }}
                            bg="white"
                            borderColor="blackAlpha.300"
                        >
                            {showMore ? 'Show Less' : 'Show More'}
                        </ChipButton>
                    </WrapItem>
                )}
            </Wrap>
        </SharedStack>
    )
}
